import {InvoiceDeleted} from "@/enum/InvoiceStatus";

export default class {
    _id;
    _order;

    _status;
    _invoices;

    _number;
    _date;
    _waybillNumber;
    _waybillDate;
    _contractNumber;
    _contractDate;
    _createdOn;
    _isAccepted;
    _acceptedOn;
    _isDeclined;
    _lastDeclinedOn;
    _total;
    _totalInWords;

    _customerInn;
    _customerName;
    _consigneeInn;
    _consigneeName;
    _deliveryAddress;
    _loadingAddress;

    _driverName;
    _carSerial;
    _carModel;

    _isTrailer;
    _isSemiTrailer;
    _trailerSerial;
    _trailerModel;
    _deliveryDateTime;


    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }

    get order() {
        return this._order
    }

    set order(value) {
        this._order = value
    }

    get status() {
        return this._status
    }

    set status(value) {
        this._status = value
    }

    get number() {
        return this._number
    }

    set number(value) {
        this._number = value
    }

    get date() {
        return this._date
    }

    set date(value) {
        this._date = value
    }

    get waybillNumber() {
        return this._waybillNumber
    }

    set waybillNumber(value) {
        this._waybillNumber = value
    }

    get waybillDate() {
        return this._waybillDate
    }

    set waybillDate(value) {
        this._waybillDate = value
    }

    get contractNumber() {
        return this._contractNumber
    }

    set contractNumber(value) {
        this._contractNumber = value
    }

    get contractDate() {
        return this._contractDate
    }

    set contractDate(value) {
        this._contractDate = value
    }

    get createdOn() {
        return this._createdOn
    }

    set createdOn(value) {
        this._createdOn = value
    }

    get isAccepted() {
        return this._isAccepted
    }

    set isAccepted(value) {
        this._isAccepted = value
    }

    get acceptedOn() {
        return this._acceptedOn
    }

    set acceptedOn(value) {
        this._acceptedOn = value
    }

    get isDeclined() {
        return this._isDeclined
    }

    set isDeclined(value) {
        this._isDeclined = value
    }

    get lastDeclinedOn() {
        return this._lastDeclinedOn
    }

    set lastDeclinedOn(value) {
        this._lastDeclinedOn = value
    }

    get total() {
        return this._total
    }

    set total(value) {
        this._total = value
    }

    get totalInWords() {
        return this._totalInWords
    }

    set totalInWords(value) {
        this._totalInWords = value
    }

    get customerInn() {
        return this._customerInn
    }

    set customerInn(value) {
        this._customerInn = value
    }

    get customerName() {
        return this._customerName
    }

    set customerName(value) {
        this._customerName = value
    }

    get consigneeInn() {
        return this._consigneeInn
    }

    set consigneeInn(value) {
        this._consigneeInn = value
    }

    get consigneeName() {
        return this._consigneeName
    }

    set consigneeName(value) {
        this._consigneeName = value
    }

    get deliveryAddress() {
        return this._deliveryAddress
    }

    set deliveryAddress(value) {
        this._deliveryAddress = value
    }

    get loadingAddress() {
        return this._loadingAddress
    }

    set loadingAddress(value) {
        this._loadingAddress = value
    }

    get driverName() {
        return this._driverName
    }

    set driverName(value) {
        this._driverName = value
    }

    get carSerial() {
        return this._carSerial
    }

    set carSerial(value) {
        this._carSerial = value
    }

    get carModel() {
        return this._carModel
    }

    set carModel(value) {
        this._carModel = value
    }

    get isTrailer() {
        return this._isTrailer
    }

    set isTrailer(value) {
        this._isTrailer = value
    }

    get isSemiTrailer() {
        return this._isSemiTrailer
    }

    set isSemiTrailer(value) {
        this._isSemiTrailer = value
    }

    get trailerSerial() {
        return this._trailerSerial
    }

    set trailerSerial(value) {
        this._trailerSerial = value
    }

    get trailerModel() {
        return this._trailerModel
    }

    set trailerModel(value) {
        this._trailerModel = value
    }

    get deliveryDateTime() {
        return this._deliveryDateTime
    }

    set deliveryDateTime(value) {
        this._deliveryDateTime = value
    }

    get invoices() {
        return this._invoices
    }

    set invoices(value) {
        this._invoices = value
    }

    get invoice() {
        return this._invoices.find(x => x.status  !== InvoiceDeleted) || null
    }
}